
    const data = {"name":"src/core/icons/view-dashboard","data":{"width":"24","height":"24","viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M13 3v6h8V3m-8 18h8V11h-8M3 21h8v-6H3m0-2h8V3H3v10Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            